appSocial.component('category', {
    templateUrl: 'pages/leaders/components/category/CategoryComponent.html',
    bindings: {
        categories: '<',
        activeCategory: '<',
        onSelect: '&'
    },
    controller: class CategoryComponent {
        constructor($state, SocialLocaleService) {
            this.translation = SocialLocaleService.translation;
            this.$state = $state;
        }

        setCategory(category) {
            // TODO set scroll position to active category
            this.onSelect({value: category});
        }

        resetCategory() {
            this.onSelect({value: this.categories[0]})
        }

        $onInit() {
        }

        $onChanges(changes) {
        }
    }
});
